import React, { useState } from "react";

const InventoryAudit = () => {
  const [inventory, setInventory] = useState([
    { id: 1, name: "Product A", expected: 100, actual: 95, status: null },
    { id: 2, name: "Product B", expected: 200, actual: 210, status: null },
  ]);

  const handleAudit = (id, status) => {
    setInventory(
      inventory.map((item) =>
        item.id === id ? { ...item, status } : item
      )
    );
  };

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">盤點紀錄審核</h2>
      <table className="table-auto w-full text-left">
        <thead>
          <tr>
            <th>商品名稱</th>
            <th>預計庫存</th>
            <th>實際庫存</th>
            <th>差異</th>
            <th>狀態</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          {inventory.map((item) => (
            <tr key={item.id} className="border-t">
              <td>{item.name}</td>
              <td>{item.expected}</td>
              <td>{item.actual}</td>
              <td className={item.expected !== item.actual ? "text-red-500" : ""}>
                {item.expected - item.actual}
              </td>
              <td>{item.status ? (item.status === 'approved' ? '同意' : '駁回') : '待審核'}</td>
              <td>
                <button
                  className="bg-green-500 text-white p-2 rounded mr-2"
                  onClick={() => handleAudit(item.id, 'approved')}
                >
                  同意
                </button>
                <button
                  className="bg-red-500 text-white p-2 rounded"
                  onClick={() => handleAudit(item.id, 'rejected')}
                >
                  駁回
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InventoryAudit;
